import React, { useState } from "react";
import PhoneInput from 'react-phone-number-input';
import clsx from "clsx";
import 'react-phone-number-input/style.css';
import './index.scss'

interface InputProps {
  name: string;
  label?: string;
  id: string;
  defaultCountry?: any;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  errorMessage?: string;
  className?: string;
  placeholder?: string;
  type?: string;
  value?: any;
  onBlur?: (_: any, name: string) => void;
  onKeyDown?: (_: any) => void;
  onChange?: (_: any, name: string) => void;
}

const PhoneInputComponent: React.FC<InputProps> = ({
  label, id, defaultCountry, disabled, name, required, error, errorMessage, className, placeholder, type, value, onBlur, onKeyDown, onChange
}) => {
  const [focused, setFocused] = useState<boolean>(false)

  return (
    <>
      <PhoneInput
        placeholder={placeholder}
        type={type}
        defaultCountry={defaultCountry}
        value={value}
        id={id}
        name={name}
        international={false}
        autoComplete="off"
        className={clsx('form-control d-flex', className, disabled && 'disabled pe-none', error && 'is-invalid', focused && !error && 'border-2 border-primary')}
        onFocus={() => setFocused(true)}
        onBlur={(e) => {setFocused(false); onBlur && onBlur(e, name)}}
        onKeyDown={onKeyDown}
        onChange={(value) => onChange && onChange({ target: { value } }, name)}
        required={required}
      />
      {label && <label htmlFor={id} className={clsx(disabled && 'text-muted', focused && 'text-primary')}>{label} {required && <span className="text-danger">*</span>}</label>}
      {
        error &&
        <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback">
          <div data-field={id} data-validator="notEmpty">
            {errorMessage}
          </div>
        </div>
      }
    </>
  )
};

export default PhoneInputComponent;